/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
    Form, Input, Button, Checkbox, Divider, Row, Col,
} from 'antd';
import { MailOutlined, LockOutlined } from '@ant-design/icons';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PasswordRecovery from '../../components/PasswordRecovery';
import { loginAsync, recoverPassword } from '../../redux/actions/auth';
import { getLang } from '../../config/helpers';
import './styles.css';
import TEXTS from './_texts/Login.texts';

const lang = getLang();

const LoginForm = ({ loginAsync }) => {
    const [visibleRecoverPW, setVisibleRecoverPW] = useState(false);

    const onFinish = (values) => {
        loginAsync(values);
    };

    const handlePWRecoverModal = () => {
        setVisibleRecoverPW(!visibleRecoverPW);
    };

    const recovrPW = async (email) => {
        await recoverPassword(email);
        handlePWRecoverModal();
    };

    return (
        <>
            <Form
                size="large"
                name="login-form"
                className="login-form"
                initialValues={{ remember: true }}
                onFinish={onFinish}
            >
                <Form.Item
                    name="email"
                    rules={[
                        {
                            type: 'email',
                            message: TEXTS.inputErrorTypeEmail[lang],
                        },
                        {
                            required: true,
                            message: TEXTS.inputErrorRequired[lang],
                        },
                    ]}
                >
                    <Input
                        prefix={<MailOutlined className="site-form-item-icon" />}
                        placeholder="Email"
                    />
                </Form.Item>
                <Form.Item
                    name="password"
                    rules={[{ required: true, message: TEXTS.inputPasswordError[lang] }]}
                >
                    <Input.Password
                        prefix={<LockOutlined className="site-form-item-icon" />}
                        placeholder={TEXTS.inputPassword[lang]}
                    />
                </Form.Item>
                <Form.Item>
                    <Form.Item name="remember" valuePropName="checked" noStyle>
                        <Checkbox>{TEXTS.checkboxRemember[lang]}</Checkbox>
                    </Form.Item>
                </Form.Item>

                <Form.Item>
                    <Button
                        type="primary"
                        htmlType="submit"
                        className="login-form-button"
                    >
                        {TEXTS.loginSubmitButton[lang]}
                    </Button>
                    <Divider />
                    <Button
                        onClick={() => {
                            handlePWRecoverModal();
                        }}
                        size="middle"
                        type="link"
                        className="center-button"
                    >
                        {TEXTS.buttonForgetPW[lang]}
                    </Button>
                </Form.Item>
            </Form>
            <PasswordRecovery
                visible={visibleRecoverPW}
                handleCancel={handlePWRecoverModal}
                handleOk={recovrPW}
                loading={false}
            />
            <Row>
                <Col span={24}>
                    {JSON.parse(localStorage.getItem('disconnected')) ? (
                        <p className="disconnect">
                            Vous avez été déconnecté pour cause d'inactivité.
                        </p>
                    ) : (
                        ''
                    )}
                </Col>
            </Row>
        </>
    );
};

LoginForm.propTypes = {
    loginAsync: PropTypes.func.isRequired,
};

const dispatchToProps = dispatch => bindActionCreators(
    {
        loginAsync,
    },
    dispatch,
);

export default connect(null, dispatchToProps)(LoginForm);
